import {
  Component,
  Input,
  forwardRef,
  HostBinding,
  ChangeDetectionStrategy,
  type OnDestroy,
} from '@angular/core';
import { type ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { ColorPickerModule } from 'ngx-color-picker';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'pt-colour-picker',
  templateUrl: './colour-picker.component.html',
  styleUrls: ['./colour-picker.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ColourPickerComponent),
      multi: true,
    },
  ],
  imports: [CommonModule, ColorPickerModule],
})
export class ColourPickerComponent implements ControlValueAccessor, OnDestroy {
  private _onDestroy$: Subject<void> = new Subject();
  private _changed$: Subject<string> = new Subject();
  private _touched$: Subject<void> = new Subject();
  private _colour = '#123123';
  @Input() format = 'hex';
  @Input() alphaEnabled = false;
  @Input() inputHidden = false;

  @HostBinding('class.disabled')
  isDisabled = false;

  set colour(colour: string) {
    this._colour = colour;
    this._changed$.next(colour);
    this._touched$.next();
  }

  get colour(): string {
    return this._colour;
  }

  ngOnDestroy(): void {
    this._onDestroy$.next();
    this._onDestroy$.complete();
    this._changed$.complete();
    this._touched$.complete();
  }

  writeValue(colour: string | undefined): void {
    if (colour) {
      this._colour = colour;
    }
  }

  registerOnChange(fn: (value: string) => void): void {
    this._changed$.pipe(takeUntil(this._onDestroy$)).subscribe(fn);
  }

  registerOnTouched(fn: () => void): void {
    this._touched$.pipe(takeUntil(this._onDestroy$)).subscribe(fn);
  }

  setDisabledState(isDisabled: boolean): void {
    this.isDisabled = isDisabled;
  }

  handleClick($event: MouseEvent): void {
    if (this.isDisabled) {
      $event.stopPropagation();
    }
  }
}
